export const MonthMap = new Map<
  string,
  {
    fullName: string;
    monthNumber: number;
  }
>();
MonthMap.set('Jan', {
  fullName: 'January',
  monthNumber: 1,
});
MonthMap.set('Feb', {
  fullName: 'February',
  monthNumber: 2,
});
MonthMap.set('Mar', {
  fullName: 'March',
  monthNumber: 3,
});
MonthMap.set('Apr', {
  fullName: 'April',
  monthNumber: 4,
});
MonthMap.set('May', {
  fullName: 'May',
  monthNumber: 5,
});
MonthMap.set('Jun', {
  fullName: 'June',
  monthNumber: 6,
});
MonthMap.set('Jul', {
  fullName: 'July',
  monthNumber: 7,
});
MonthMap.set('Aug', {
  fullName: 'August',
  monthNumber: 8,
});
MonthMap.set('Sep', {
  fullName: 'September',
  monthNumber: 9,
});
MonthMap.set('Oct', {
  fullName: 'October',
  monthNumber: 10,
});
MonthMap.set('Nov', {
  fullName: 'November',
  monthNumber: 11,
});
MonthMap.set('Dec', {
  fullName: 'December',
  monthNumber: 12,
});
